// Minimal RFC-4180 CSV read/write — no dependency. Used to round-trip the LOCAL
// libraries (Goals / Services / Vendors) through Excel: export → edit in Excel →
// import back. CSV opens natively in Excel and survives the round-trip.

// rows: array of objects. columns: [{ key, header }]. Returns CSV text with a
// header row (CRLF line endings, which Excel prefers).
export function toCSV(rows, columns) {
  const esc = (v) => {
    const s = v == null ? "" : String(v)
    return /[",\n\r]/.test(s) ? `"${s.replace(/"/g, '""')}"` : s
  }
  const header = columns.map(c => esc(c.header)).join(",")
  const body = (Array.isArray(rows) ? rows : [])
    .map(r => columns.map(c => esc(r[c.key])).join(","))
    .join("\r\n")
  return body ? `${header}\r\n${body}` : header
}

// Parse CSV text → array of row objects keyed by the header row. Handles quoted
// fields containing commas, quotes ("" escaping) and newlines, plus a leading
// UTF-8 BOM and \r\n / \r / \n line endings. Blank lines are skipped.
export function parseCSV(text) {
  const s = String(text == null ? "" : text).replace(/^﻿/, "")
  const rows = []
  let row = []
  let field = ""
  let inQuotes = false
  const endField = () => { row.push(field); field = "" }
  const endRow = () => { endField(); rows.push(row); row = [] }
  for (let i = 0; i < s.length; i++) {
    const c = s[i]
    if (inQuotes) {
      if (c === '"') {
        if (s[i + 1] === '"') { field += '"'; i++ } else inQuotes = false
      } else field += c
    } else if (c === '"') {
      inQuotes = true
    } else if (c === ",") {
      endField()
    } else if (c === "\n") {
      endRow()
    } else if (c === "\r") {
      if (s[i + 1] === "\n") i++
      endRow()
    } else field += c
  }
  if (field.length || row.length) endRow()
  if (!rows.length) return []
  const headers = rows.shift().map(h => String(h).trim())
  return rows
    .filter(r => r.some(v => String(v).trim() !== ""))
    .map(r => {
      const o = {}
      headers.forEach((h, idx) => { o[h] = r[idx] != null ? r[idx] : "" })
      return o
    })
}

// Download CSV text as a file. Prepends a UTF-8 BOM so Excel opens accented
// characters correctly.
export function downloadCSV(text, filename) {
  if (typeof document === "undefined") return
  const blob = new Blob(["﻿" + text], { type: "text/csv;charset=utf-8" })
  const url = URL.createObjectURL(blob)
  const a = document.createElement("a")
  a.href = url
  a.download = filename
  document.body.appendChild(a)
  a.click()
  a.remove()
  setTimeout(() => URL.revokeObjectURL(url), 1000)
}
